import script from "./VoucherForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherForm.vue?vue&type=script&setup=true&lang=js"

import "./VoucherForm.vue?vue&type=style&index=0&id=79c3f6d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c3f6d2"]])

export default __exports__